import React from 'react';

export default () => {
    return (
        <div className="tips-for-import-container">
            <div className="tips-header">
                <h2>Tips for import</h2>
            </div>
            <ul>
                <li>We support file sizes upto 10MB. If your file is larger than 10MB, we suggest you break it up in to
                    multiple files.
                </li>
                <li>The first row of your import file must be the column headers you wish to import.</li>
                <li>Duplicate contacts check will be performed on Email or Mobile Number.</li>
                <li>Unexpected errors may occur if XLS file do have any special styles, combo filters or images.</li>
                <li>By default, the character encoding is UTF-8 character set will be escaped.</li>
                <li>We suggest you to import a small set of sample data, before importing your actual data.</li>
                <li>Description field only supports 2000 characters max.</li>
                <li>Date format inside your excel sheet should be in any of these formats: dd/mm/yyyy | mm/dd/yyyy |
                    yyyy-mm-dd | dd MMM, yyyy | MMM dd, yyyy
                </li>
                <li>Setup custom fields before import.</li>
            </ul>
        </div>
    )
}